import styled from 'styled-components';

export const AvatarActionSC = styled.div`
  position: absolute;
  bottom: -4px;
  right: -4px;
  z-index: 2;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.color.surface.baseline};
`;
